<template>
  <div class="modal--license fixed w-full h-full top-0 left-0">
    <div class="modal--inner relative container bg-white shadow-md">
      <div
        class="button--close absolute top-0 right-0 mt-1 mr-1 cursor-pointer"
        @click="$emit('close')"
      >
        <svg
          width="42"
          height="42"
          viewBox="0 0 42 42"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M33.2138 11.2175L30.7634 8.75L21.0483 18.5325L11.3333 8.75L8.88281 11.2175L18.5978 21L8.88281 30.7825L11.3333 33.25L21.0483 23.4675L30.7634 33.25L33.2138 30.7825L23.4988 21L33.2138 11.2175Z"
            fill="#00263E"
          />
        </svg>
      </div>
      <div class="flex flex-wrap border-b-1 border-blue-default pb-1">
        <div class="w-6/12 flex items-center">
          <h4 class="font-bold text-blue-dark pl-1">
            {{ content.compare.header[0] ? content.compare.header[0] : "" }}
          </h4>
        </div>
        <div class="w-3/12 text-center text--wrapper">
          <p
            class="text-22 text-blue-dark font-semibold"
            v-html="content.compare.header[1] ? content.compare.header[1] : ''"
          ></p>
        </div>
        <div class="w-3/12 text-center text--wrapper">
          <p
            class="text-22 text-blue-dark font-semibold"
            v-html="content.compare.header[2] ? content.compare.header[2] : ''"
          ></p>
        </div>
      </div>
      <div
        class="flex flex-wrap border-b-1 border-gray-neutral-250 last:border-b-0 last:bg-white"
        :class="index % 2 !== 0 ? 'bg-gray-neutral-100 bg-opacity-50' : ''"
        v-for="(feature, index) in content.compare.features"
        :key="index"
      >
        <div
          class="w-6/12 flex items-center border-r-1 border-gray-neutral-250"
        >
          <p class="text-blue-dark text-xl my-1 pl-1">
            {{ feature.title }}
          </p>
        </div>
        <div
          class="w-3/12 flex items-center justify-center text-center border-r-1 border-gray-neutral-250"
        >
          <svg
            v-if="feature.col1 === true"
            width="12"
            height="12"
            viewBox="0 0 12 12"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <ellipse cx="6.02014" cy="6" rx="5.95862" ry="6" fill="#00263E" />
          </svg>
          <span v-else-if="feature.col1 === false"></span>
          <p
            v-else-if="
              (feature.col1 !== true || feature.col1 !== false) && feature.col1
            "
            class="text-blue-dark text-xl px-1"
          >
            {{ feature.col1 }}
          </p>
        </div>
        <div class="w-3/12 flex items-center justify-center text-center">
          <svg
            v-if="feature.col2 === true"
            width="12"
            height="12"
            viewBox="0 0 12 12"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <ellipse cx="6.02014" cy="6" rx="5.95862" ry="6" fill="#00263E" />
          </svg>
          <span v-else-if="feature.col2 === false"></span>
          <p
            v-else-if="
              (feature.col2 !== true || feature.col2 !== false) && feature.col2
            "
            class="text-blue-dark text-xl px-1"
          >
            {{ feature.col2 }}
          </p>
        </div>
      </div>
    </div>
  </div>
</template>
<style lang="scss" scoped>
.modal--license {
  background: rgba(#f6f7f9, 0.9);
  z-index: 99;
}
.modal--inner {
  top: calc(50% + 80px);
  transform: translateY(-50%);
  padding: 120px 40px 50px 40px;
  height: 85vh;
  overflow-y: scroll;
  border-radius: 10px;
}
.text--wrapper ::v-deep {
  span {
    font-weight: 400;
    display: block;
  }
}
</style>
<script>
export default {
  props: {
    content: {
      required: true,
      type: Object,
    },
  },
};
</script>
